import { render, staticRenderFns } from "./DigitalLife.vue?vue&type=template&id=32f0a760&scoped=true"
import script from "./DigitalLife.vue?vue&type=script&lang=js"
export * from "./DigitalLife.vue?vue&type=script&lang=js"
import style0 from "./DigitalLife.vue?vue&type=style&index=0&id=32f0a760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f0a760",
  null
  
)

export default component.exports